// Imports
import React from 'react';
import styled, { ThemeProvider } from 'styled-components/macro';
import ButtonGroup from '../../../../../shareables/foundation/front-end/components/buttons/group';
import { genericColorLookup } from '../../../../../shareables/foundation/front-end/components/buttons/standard';


// Styled component
const Container = styled(ButtonGroup)`
	margin-bottom: 0.25rem;
`;


// Function component
const PageActions: React.FC<React.PropsWithChildren> = ({ children }) => {
	// Return JSX
	return (
		<ThemeProvider
			theme={{
				boxShadow: '0 0.125em 0.25em rgba(0, 0, 0, 0.05)',
				iconColor: '#363636',
				borderColor: genericColorLookup.gray,
			}}
		>
			<Container>{children}</Container>
		</ThemeProvider>
	);
};

export default PageActions;
